import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'

import {
  getEffectiveTheme,
  useSessionLanguage,
  useSessionTheme,
} from '@context/SessionSettingsContext'

import { Body2 } from '@ui/Typography'

import { useGAEvents } from '@utils/callGAEvents'

import { mapAcuityLocale } from '@global/locale/Locale'

import { useScrollToTopOnRouteChange } from '@hooks/useScrollToTop'

import { AcquityHeader } from '../AcquityHeader'

import styles from './ResearchTerminal.module.scss'

declare const window: Window & { AcuityWidgets: any }

export const ResearchTerminal: React.FC = () => {
  useScrollToTopOnRouteChange()

  const { t } = useTranslation()
  const locale = useSessionLanguage()
  const [mountTime] = useState(new Date())
  const { callGAEvents } = useGAEvents()
  const theme = useSessionTheme()

  const effectiveTheme = getEffectiveTheme(theme)

  const researchTerminalWidgetRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    callGAEvents().Tools.Links.researchTerminal()

    return () => {
      const spentTime = Math.round((new Date().getTime() - mountTime.getTime()) / 1000)
      callGAEvents({
        time_spent_in_seconds: spentTime,
      }).Tools.TimeSpent.researchTerminal()
    }
  }, [])

  useEffect(() => {
    window.AcuityWidgets.globals({
      apikey: 'f3eb0d37-bce0-40e2-bf70-1ce9fbfb8d90',
      locale: mapAcuityLocale(locale),
    })

    const widget = window.AcuityWidgets.CreateWidget(
      'acuityresearchterminal',
      researchTerminalWidgetRef.current,
      { settingId: effectiveTheme === 'light' ? 6991 : 5362 }
    )

    widget.mount()

    return () => {
      widget.unmount && widget.unmount()
    }
  }, [locale, effectiveTheme])

  return (
    <>
      <AcquityHeader
        title={t('Research Terminal')}
        description={t('Elevate your trading experience with Research Terminal')}
      />
      <div id='acuity-research-terminal' ref={researchTerminalWidgetRef}></div>
      <div className={styles.disclaimer}>
        <Body2 isParagraph className={styles.disclaimerText}>
          {t(
            'Any information or comments provided by third parties do not reflect the views of Tickmill'
          )}
        </Body2>
        <Body2 isParagraph className={styles.disclaimerText}>
          {t(
            'All content is for information purposes only and should not be considered as investment advice or research'
          )}
        </Body2>
      </div>
    </>
  )
}
